import useTableStateParams from "@/components/Table/hooks/useTableState";

import BorderContainer from "@/components/ContentContainer/BorderContainer";
import Skeleton from "@/components/Skeleton/Skeleton";
import Table from "@/components/Table/Table";
import styles from "@/pages/goods_and_services/GoodsAndServicesItemDetail/GoodsAndServicesItemDetail.module.scss";
import { Tag } from "antd";
import {
  GoodsAndServicesItemRelation,
  useGetGoodsAndServicesItem,
  useGetGoodsAndServicesItemRelations,
} from "../useGoodsAndServices";
import GoodsAndServicesItemRelationsPerYear from "./GoodsAndServicesItemRelationsPerYear";

export default function GoodsAndServicesItemRelations({
  goodsAndServicesItemId,
}: {
  goodsAndServicesItemId: number;
}) {
  const { pagination, onSearchFilterSortPaginate } = useTableStateParams({
    defaultPagination: { page: 1, pageSize: 10 },
  });
  const { data, isLoading, isFetching } = useGetGoodsAndServicesItemRelations({
    goodsAndServicesItemId,
    pagination,
  });
  const { data: goodsAndServicesItem, isLoading: goodsAndServicesItemIsLoading } =
    useGetGoodsAndServicesItem({
      goodsAndServicesItemId,
    });

  if (data?.total_count === 0)
    return (
      <BorderContainer>This good or service is not referenced in any facility.</BorderContainer>
    );

  return (
    <>
      <div className={styles.relationContainer}>
        <div className={styles.item}>
          <h3>Facilities</h3>
          <span className={styles.metric}>
            <Skeleton
              loading={goodsAndServicesItemIsLoading}
              style={{ width: 20, height: 24 }}
            >
              {goodsAndServicesItem?.facility_relations}
            </Skeleton>
          </span>
        </div>
      </div>
      <GoodsAndServicesItemRelationsPerYear goodsAndServicesItemId={goodsAndServicesItemId} />
      <Table<GoodsAndServicesItemRelation>
        loading={isLoading || isFetching}
        type="grey"
        emptyState={{ hide: true }}
        hideRaster={true}
        pagination={pagination}
        totalRows={data?.total_count}
        data={data?.data}
        onSearchFilterSortPaginate={onSearchFilterSortPaginate}
        rowLink={(record) =>
          ["product_proxy", "product_source", "product"].includes(record.type)
            ? `/products/${record.id}/usage`
            : `/facilities/${record.id}`
        }
        columns={[
          {
            label: "Name",
            key: "name",
            renderer: (record) => record.name,
          },
          {
            label: "Relation",
            key: "relation",
            renderer: (record) => <Tag>Facility</Tag>,
          },
        ]}
        rowKey={"id"}
      />
    </>
  );
}
